var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70999 9.09C6.61728 9.18252 6.54373 9.2924 6.49355 9.41338C6.44337 9.53435 6.41754 9.66403 6.41754 9.795C6.41754 9.92597 6.44337 10.0557 6.49355 10.1766C6.54373 10.2976 6.61728 10.4075 6.70999 10.5L11.3 15.09C11.3925 15.1827 11.5024 15.2563 11.6234 15.3064C11.7443 15.3566 11.874 15.3824 12.005 15.3824C12.136 15.3824 12.2656 15.3566 12.3866 15.3064C12.5076 15.2563 12.6175 15.1827 12.71 15.09L17.3 10.5C17.3926 10.4074 17.466 10.2975 17.5161 10.1765C17.5662 10.0556 17.592 9.92593 17.592 9.795C17.592 9.66407 17.5662 9.53442 17.5161 9.41346C17.466 9.29249 17.3926 9.18258 17.3 9.09C17.2074 8.99742 17.0975 8.92398 16.9765 8.87387C16.8556 8.82377 16.7259 8.79798 16.595 8.79798C16.4641 8.79798 16.3344 8.82377 16.2134 8.87387C16.0925 8.92398 15.9826 8.99742 15.89 9.09L12 12.97L8.11999 9.09C7.72999 8.71 7.08999 8.71 6.70999 9.09Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/downIcon.cc4d6677c75b624cec85742e4ad5321a.svg";
export { ForwardRef as ReactComponent };